import { useState, useEffect } from 'react';
import { faqData } from '../../../mocks/faq';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    // Add FAQ Schema
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqData.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    let scriptElement = document.querySelector('script[data-faq-schema]');
    if (!scriptElement) {
      scriptElement = document.createElement('script');
      scriptElement.setAttribute('type', 'application/ld+json');
      scriptElement.setAttribute('data-faq-schema', 'true');
      document.head.appendChild(scriptElement);
    }
    scriptElement.textContent = JSON.stringify(faqSchema, null, 2);

    return () => {
      const element = document.querySelector('script[data-faq-schema]');
      if (element) {
        element.remove();
      }
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-8 lg:px-16 max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            よくある質問
          </h2>
          <p className="text-lg text-gray-600">FAQ</p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <article
              key={faq.id}
              className="bg-gray-50 rounded-2xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center gap-4 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">Q</span>
                </div>
                <h3 className="flex-1 text-base md:text-lg font-bold text-gray-900">
                  {faq.question}
                </h3>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-primary transition-transform duration-300`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 pl-20">
                  <div className="bg-white rounded-xl p-4 md:p-6">
                    <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
